import { useState, useEffect } from "react";

/**
 * Detects whether the app is running in standalone/PWA mode (installed as APK).
 * Uses CSS display-mode query + navigator standalone check.
 */
export function useIsStandalone(): boolean {
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Check CSS display-mode (works in most modern browsers)
    const mq = window.matchMedia("(display-mode: standalone)");
    if (mq.matches) {
      setIsStandalone(true);
      return;
    }

    // Fallback: navigator.standalone (iOS Safari)
    if ("standalone" in navigator && (navigator as any).standalone) {
      setIsStandalone(true);
      return;
    }

    // Listen for display-mode changes (e.g. user installs app while browsing)
    const handler = (e: MediaQueryListEvent) => setIsStandalone(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isStandalone;
}

export const isStandaloneMode = (): boolean => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (navigator as any).standalone === true
  );
};
